export function isAllStudentsAbsentFromStatuses(statuses) {
  if (!Array.isArray(statuses) || statuses.length === 0) return false;
  if (statuses.some((s) => !s || !String(s).trim())) return false;
  return statuses.every((s) => String(s).toLowerCase() === 'absent');
}

export function isAllStudentsAbsentFromStudents(students, attendanceDraft = {}) {
  if (!Array.isArray(students) || students.length === 0) return false;
  const statuses = students.map(
    (s) => attendanceDraft[s.student_id] ?? s.attendanceStatus ?? s.attendance_status ?? null
  );
  return isAllStudentsAbsentFromStatuses(statuses);
}

export function isSessionWorkWaived({ allStudentsAbsent, isCancelled } = {}) {
  return !!isCancelled || !!allStudentsAbsent;
}

/** Next class plan is required for sessions on/after this date (YYYY-MM-DD). */
export const NEXT_PLAN_REQUIRED_FROM = '2026-08-13';

export function isNextPlanRequiredForSessionDate(sessionDateYmd) {
  const ymd = String(sessionDateYmd || '').slice(0, 10);
  return Boolean(ymd && ymd >= NEXT_PLAN_REQUIRED_FROM);
}

export function isNextPlanMissing({ sessionDate, hasPlan, waived } = {}) {
  if (waived) return false;
  if (!isNextPlanRequiredForSessionDate(sessionDate)) return false;
  return !hasPlan;
}
